module.exports = __webpack_public_path__ + "img/income-and-expense-log_B09K2BFSPT.46979a55.jpg";